import cn from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GerenciadorPrecos } from '../../../../../../@types/GerenciadorPrecos';
import { ButtonSecondary, SecondaryButtonProps } from '../../../../../../components';
import {
  ADD_GERENCIADOR_EXPANDED_ROW_OPTION,
  REMOVE_GERENCIADOR_EXPANDED_ROW_OPTION,
  RESET_GERENCIADOR_EXPANDED_ROW,
  SET_GERENCIADOR_EXPANDED_ROW_KEY,
  selectorExpandedRowKey,
} from '../../../../../../reducers/gerenciadorPrecos/expandedRowKey';
import { selectorOfferDataView } from '../../../../../../reducers/gerenciadorPrecos/offerDataView';
import { hasHighlightedOfferPriceStatus } from '../../../utils';
import { BaseCell } from '../BaseCell';
import { BaseCellProps } from '../BaseCell/BaseCell';
import styles from './ExpandOfferCell.module.scss';

type ExpandOfferCellProps = BaseCellProps & {
  rowData: GerenciadorPrecos.RowData;
  theme?: SecondaryButtonProps['skin'];
  children?: React.ReactNode;
};

const ExpandOfferCell = ({ rowData, handleContextMenu, theme, className, children }: ExpandOfferCellProps) => {
  const { productsToBePricedId, offerDetails } = rowData;

  const dispatch = useDispatch();

  const { key, options } = useSelector(selectorExpandedRowKey);
  const { autoExpandRows } = useSelector(selectorOfferDataView);

  const isExpanded = useMemo(() => {
    return key === productsToBePricedId && options.includes('OFFER');
  }, [key, productsToBePricedId, options]);

  const handleExpandOfferRow = useCallback(() => {
    if (autoExpandRows) return;

    if (key !== productsToBePricedId) {
      dispatch(RESET_GERENCIADOR_EXPANDED_ROW());
    }

    if (isExpanded) {
      dispatch(REMOVE_GERENCIADOR_EXPANDED_ROW_OPTION('OFFER'));
      return;
    }

    dispatch(SET_GERENCIADOR_EXPANDED_ROW_KEY(productsToBePricedId));
    dispatch(ADD_GERENCIADOR_EXPANDED_ROW_OPTION('OFFER'));
  }, [autoExpandRows, dispatch, isExpanded, key, productsToBePricedId]);

  const newTheme = useMemo(() => theme || (isExpanded || hasHighlightedOfferPriceStatus(rowData) ? 'blue' : 'gray'), [isExpanded, rowData, theme]);

  if (!offerDetails) return null;

  return (
    <BaseCell className={cn(className, styles.wrapper)} rowData={rowData} handleContextMenu={handleContextMenu}>
      <ButtonSecondary onClick={handleExpandOfferRow} theme={newTheme} disabled={autoExpandRows}>
        {children}
      </ButtonSecondary>
    </BaseCell>
  );
};

export default ExpandOfferCell;
